import * as yup from 'yup';

export default yup.object({
    persona: yup.object().required('Persona is a required field')
});
